var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "109px",
    viewBox: "0 0 108 109",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-(out-of-date)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9302419,20 C85.5870961,20 86.9302419,21.3431458 86.9302419,23 C86.9302419,23.0229847 86.9299777,23.0459687 86.9294495,23.0689473 L85.0673805,104.068947 C85.0299194,105.698507 83.6981628,107 82.0681729,107 L24.9318271,107 C23.3018372,107 21.9700806,105.698507 21.9326195,104.068947 L20.0705505,23.0689473 C20.032472,21.4125307 21.3443942,20.0388709 23.0008108,20.0007924 L83.9302419,20 Z M33.5,29 C32.1745166,29 31.0899613,30.0315359 31.0053177,31.3356243 L31,31.5 L31,96.5 C31,97.8807119 32.1192881,99 33.5,99 C34.8254834,99 35.9100387,97.9684641 35.9946823,96.6643757 L36,96.5 L36,31.5 C36,30.1192881 34.8807119,29 33.5,29 Z M74,29.2117647 C72.6745166,29.2117647 71.5899613,30.2433006 71.5053177,31.547389 L71.5,31.7117647 L71.5,96.3117647 C71.5,97.6924766 72.6192881,98.8117647 74,98.8117647 C75.3254834,98.8117647 76.4100387,97.7802288 76.4946823,96.4761404 L76.5,96.3117647 L76.5,31.7117647 C76.5,30.3310528 75.3807119,29.2117647 74,29.2117647 Z M54,29.2117647 C52.6745166,29.2117647 51.5899613,30.2433006 51.5053177,31.547389 L51.5,31.7117647 L51.5,96.3117647 C51.5,97.6924766 52.6192881,98.8117647 54,98.8117647 C55.3254834,98.8117647 56.4100387,97.7802288 56.4946823,96.4761404 L56.5,96.3117647 L56.5,31.7117647 C56.5,30.3310528 55.3807119,29.2117647 54,29.2117647 Z M59.5,1 C61.1568542,1 62.5,2.34314575 62.5,4 L62.5,6 L86.5,6 C88.1568542,6 89.5,7.34314575 89.5,9 L89.5,15 C89.5,16.1045695 88.6045695,17 87.5,17 L19.5,17 C18.3954305,17 17.5,16.1045695 17.5,15 L17.5,9 C17.5,7.34314575 18.8431458,6 20.5,6 L44.5,6 L44.5,4 C44.5,2.34314575 45.8431458,1 47.5,1 L59.5,1 Z",
    id: "Combined-Shape",
    fill: "#167167"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1ea8e2b4d38e903bcf180a3ba1cb21dc.svg";
export { ForwardRef as ReactComponent };